import React, { useState, useEffect } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import BlogPostComponent from '../components/blog/BlogPost';
import { getBlogPostBySlug } from '../utils/markdown';
import settings from '../constants/settings';

const BlogPost = () => {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);
  
  useEffect(() => {
    const fetchPost = async () => {
      try {
        setLoading(true);
        const fetchedPost = await getBlogPostBySlug(slug);
        if (fetchedPost) {
          setPost(fetchedPost);
        } else {
          setNotFound(true);
        }
      } catch (error) {
        console.error('Error loading blog post:', error);
        setNotFound(true);
      } finally {
        setLoading(false);
      }
    };
    
    fetchPost();
  }, [slug]);
  
  // Redirect to blog index if post not found
  if (notFound) {
    return <Navigate to="/blog" />;
  }
  
  return (
    <div className="blog-post page-container mt-[90px]">
      <Helmet>
        <title>{post ? `${post.title} | Blog #PintarPilihKuliah` : 'Loading...'}</title>
        <meta name="description" content={post ? post.excerpt : ''} />
        {post && post.coverImage && (
          <meta property="og:image" content={post.coverImage} />
        )}
        <meta property="og:type" content="article" />
        <meta property="og:title" content={post ? post.title : 'Blog #PintarPilihKuliah'} />
        <meta property="og:description" content={post ? post.excerpt : ''} />
        <meta property="og:site_name" content={settings.app_name} />
      </Helmet>
      
      <section className="py-12">
        {loading ? (
          <div className="container mx-auto px-4">
            <div className="flex justify-center items-center h-64">
              <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-gold"></div>
            </div>
          </div>
        ) : (
          <div className="container mx-auto px-4">
            <BlogPostComponent post={post} />
          </div>
        )}
      </section>
    </div>
  );
};

export default BlogPost;